module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_footer_eight-dbd49224f0306176f2dd8c381fbd7943.svg";